import map from "lodash/map";
import classnames from "classnames";
import CloseButton from "Shared/CloseButton";
import PropTypes from "prop-types";
import React from "react";
import ScrollAreaContainer from "containers/ScrollAreaContainer";
import ChapterSlideshowTile from "./ChapterSlideshowTile";

export default class ChapterSlideshow extends React.PureComponent {
  static propTypes = {
    chapters: PropTypes.array.isRequired,
    needsModifiedScrollbars: PropTypes.bool.isRequired,
    onChapterClick: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  renderChapterTiles() {
    return map(this.props.chapters, (chapterId) => (
      <ChapterSlideshowTile
        chapterId={chapterId}
        key={`chapter_${chapterId}`}
        onClick={this.props.onChapterClick}
      />
    ));
  }

  render() {
    return (
      <div
        aria-label="Chapter List"
        className="chapter-slideshow-wrap"
        role="list"
      >
        <div className="chapter-slideshow-controls">
          <CloseButton onClick={this.props.onClose} />
        </div>
        <ScrollAreaContainer
          className={classnames("chapter-slideshow-container", {
            "chapter-slideshow-container--native-scrolling":
              !this.props.needsModifiedScrollbars,
          })}
          containerClassName={classnames("chapter-slideshow", {
            "chapter-slideshow--native-scrolling":
              !this.props.needsModifiedScrollbars,
          })}
          horizontal
          smoothScrolling
          vertical={false}
        >
          {this.renderChapterTiles()}
        </ScrollAreaContainer>
      </div>
    );
  }
}
